import * as R from 'ramda'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import ArticleCard from '../../../components/ArticleCard'
import { CorporateArticleCardSkeleton } from '../../../components/Skeleton'
import { MEDIA_CONDITIONS } from '../../../constants'
import { useTracking } from '../../../hooks'
import { getArticleById } from '../../../redux/article/selectors'
import { hk01LinkHandler } from '../../../utils/commonUtils'
import { corporateHomeClickArticle } from '../../../utils/dataTracker'

const CorporateHomeArticle = React.memo(({ articleId, listView }) => {
  const track = useTracking()
  const { publishUrl, title, description, mainImage } =
    useSelector(getArticleById(articleId)) || {}
  const handleLinkClick = useCallback(e => {
    hk01LinkHandler(e)
    track(corporateHomeClickArticle(articleId))
  }, [])
  return R.isNil(articleId) ? (
    <CorporateArticleCardSkeleton listView={listView} />
  ) : (
    <a target='_blank' href={publishUrl} onClick={handleLinkClick}>
      <ArticleCard
        title={title}
        description={description}
        mainImage={R.prop('cdnUrl', mainImage)}
        listView={listView}
        imageSizes={
          listView
            ? `${MEDIA_CONDITIONS.DESKTOP_TABLET} 270px, calc(100vw - 24px)`
            : `${MEDIA_CONDITIONS.DESKTOP} calc(50vw - 12px), ${MEDIA_CONDITIONS.TABLET} calc(100vw - 128px), calc(100vw - 24px)`
        }
      />
    </a>
  )
})

export default CorporateHomeArticle
